import reduce from 'lodash/reduce'

export const getDynamicOptions = (state, fields, formValueSelector, prefix?) => {
  return reduce(
    fields,
    (result, field) => {
      // Check if field has ParentFieldID different from 0
      // Find master select by child select's ParentFieldID
      const masterSelect = field.ParentFieldID && fields.find((searchField) => searchField.ID === field.ParentFieldID) // TODO: fix check

      if (masterSelect) {
        // Get value of master field from redux form
        const masterFieldName = prefix ? `${prefix}.${masterSelect.FieldName}` : masterSelect.FieldName
        const childFieldName = prefix ? `${prefix}.${field.FieldName}` : field.FieldName
        const masterSelectValue = state ? formValueSelector(state, masterFieldName) : formValueSelector[masterFieldName]

        // Master select can have more then one child select
        const childSelects = result.masterSelects[masterFieldName] || {}

        return {
          masterSelects: {
            ...result.masterSelects,
            [masterFieldName]: {
              ...childSelects,
              [childFieldName]: field.LookupData,
            },
          },
          childSelectOptions: {
            ...result.childSelectOptions,
            [childFieldName]: field.ParentFieldID
              ? field.LookupData.filter((option) => parseInt(option.ParentID, 10) === parseInt(masterSelectValue, 10)) // TODO: fix check
              : undefined,
          },
        }
      }

      return result
    },
    { masterSelects: {}, dynamicOptions: {}, childSelectOptions: {} },
  )
}
